import { Component, OnInit } from '@angular/core';
import { TipoCertificado } from './tipo_certificado';
import { TipoCertificadoService } from './tipo_certificado.service';

import { PER_PAGE } from './../constante';

@Component({
  selector: 'app-tipos-certificados',
  templateUrl: './tipos-certificados.component.html',
  providers: [TipoCertificadoService]

})
export class TiposCertificadosComponent implements OnInit {

  public busy: Promise<any>;
  public tipo_certificados: TipoCertificado[];
  public titulo: string = "Tipo Certificados";
  public paginaAtual: number = 1;
  public itensPorPagina: number = PER_PAGE;

  constructor(private tipoCertificadoService: TipoCertificadoService) { }

  getTipos(): void {

   this.busy = this.tipoCertificadoService.getTipos()
      .then((tipos) => this.tipo_certificados = tipos);
  }

  apagar(tipo_certificados: TipoCertificado): void {
  //  this.toastyService.default('Hi there');

    if(confirm("Deseja realmente excluir essa unidade? Essa operação não pode ser revertida após a confirmação.")){
      this.busy = this.tipoCertificadoService.deleteTipoCertificado(tipo_certificados)
            .then(() => this.getTipos());
    }
  }

  ngOnInit() {
    this.getTipos();
  }

}



// WEBPACK FOOTER //
// ./src/app/tipos_certificados/tipos-certificados.component.ts